import React from "react";
import "./Header.scss";
import Help from "../Help/Help";

export default function Header() {
  const [showHelp, setShowHelp] = React.useState(false);

  function handleOnClick() {
    setShowHelp(!showHelp);
  }

  return (
    <>
      <header className="header">
        <div className="header__dropdown">
          <select name="dropdown" id="dropdown">
            <option value="All Pages">All Pages</option>
            <option value="Holiday Sales">Holiday Sales</option>
            <option value="Seasonal Campaigns">Seasonal Campaigns</option>
            <option value="Promotional Sales">Promotional Sales</option>
          </select>
        </div>
        <div className="header__logo"></div>
        <div className="header__icon-wrapper">
          <div
            className="header__help-icon header__icon"
            onClick={handleOnClick}
          ></div>
          <div className="header__notify-icon header__icon"></div>
          <div className="header__user-icon header__icon"></div>
        </div>
      </header>
      {showHelp === true && (
        <Help showHelp={showHelp} setShowHelp={setShowHelp} />
      )}
    </>
  );
}
